<template>
	<div class="main-table">
		<div class="main-table-box">
			<el-table
				class="grid-content"
				:data="acceptData"
				ref='table'
				border
				stripe
				size="mini"
				@selection-change="selectionChangeHandle"
			>
				<el-table-column
					type="selection"
					align="center"
					width="55">
				</el-table-column>
				<el-table-column label="操作" width="200" align="center">
					<template slot-scope="scope">
						<el-button type='text' size="mini" icon="el-icon-delete" @click="delGoods(scope.row)">删除</el-button>
						<el-button type='text' size="mini" @click="moveClick(scope.$index, 'top')">置顶</el-button>
						<el-button v-if="scope.$index !== 0" type='text' size="mini" @click="moveClick(scope.$index, 'up')">上移</el-button>
						<el-button v-if="scope.$index !== (acceptData.length - 1)" type='text' size="mini" @click="moveClick(scope.$index, 'down')">下移</el-button>
					</template>
				</el-table-column>
				<el-table-column
					label-class-name="column-index"
					label="序号"
					type="index"
					width="70"
					align="center">
				</el-table-column>
				<el-table-column
					prop="productname"
					label="商品名称"
					align="center"
					min-width="150">
					<template slot-scope="scope">
						<el-button type='text' size="mini" @click="goPro(scope.row)">{{scope.row.productname}}</el-button>
					</template>
				</el-table-column>
				<el-table-column
					prop="code"
					label="规格编号"
					align="center"
					min-width="150">
				</el-table-column>
				<el-table-column
					prop="spec"
					label="规格"
					align="center"
					min-width="150">
				</el-table-column>
				<el-table-column
					label="商品数量"
					align="center"
					min-width="150">
					<template slot-scope="scope">
							<el-input size='mini' v-model="scope.row.itemQuantity" type="text" onmousewheel="return false" @input="countInput(scope.row)"></el-input>
					</template>
				</el-table-column>
				<el-table-column
					label="数量可修改"
					align="center"
					min-width="150">
					<template slot-scope="scope">
						<el-checkbox v-model="scope.row.modifyflag"></el-checkbox>
					</template>
				</el-table-column>
				<el-table-column
					label="必订"
					align="center"
					min-width="150">
					<template slot-scope="scope">
						<el-checkbox v-model="scope.row.mustbuyflag"></el-checkbox>
					</template>
				</el-table-column>
				<el-table-column
					prop="bcname"
					label="店铺级大类"
					align="center"
					min-width="150">
				</el-table-column>
				<el-table-column
					v-if="bigcategoryview === 1"
					prop="scname"
					label="店铺级小类"
					align="center"
					min-width="150">
				</el-table-column>
				<el-table-column
					prop="stackflag"
					label="启用状态"
					align="center"
					min-width="150">
				</el-table-column>
				<!-- <el-table-column
					prop="salestate"
					label="可售状态"
					align="center"
					min-width="150">
				</el-table-column> -->
			</el-table>
		</div>
	</div>
</template>

<script>
export default {
	name: 'mainTable',
	props: {
		tableData: Array,
		regularpurchaseProductListId: String
	},
	data () {
		return {
			tableHeight: '100%',
			acceptData: [],
			bigcategoryview: 0,
			decimal: 0
		}
	},
	created () {
		this.checkSmallCategory()
		this.getOrderSystemSetting()
	},
	watch: {
		tableData () {
			this.acceptData = this.tableData
		}
	},
	methods: {
		goPro (data) {
			console.log(data)
			sessionStorage.setItem('productid', data.productId)
			// this.$fxGoBlank('/pickListTable', this.$router)
			this.$fxGoBlank('/main/newProduct/goodsInfoS', this.$router)
		},
		swapArray (arr, index1, index2) {
			arr[index1] = arr.splice(index2, 1, arr[index1])[0]
			return arr
		},
		moveClick (index, type) {
			if (type === 'up') {
				if (index === 0) {
					return false
				}
				this.swapArray(this.acceptData, index - 1, index)
			} else if (type === 'down') {
				if (index + 1 === this.acceptData.length) {
					return false
				}
				this.swapArray(this.acceptData, index, index + 1)
			} else {
				let list = this.$fxUtils.deepClone(this.acceptData)
				let item = list[index]
				list.splice(index, 1)
				list.unshift(item)
				this.acceptData = list
			}
			this.saveSeq()
		},
		saveSeq () {
			let list = this.acceptData
			for (let i = 0; i < list.length; i++) {
				list[i].sequm = i + 1
				list[i].modifyflag = 1
				list[i].mustbuyflag = list[i].mustbuyflag ? 1 : 0
			}
			let params = {
				regularpurchaseListId: this.regularpurchaseProductListId,
				editCartInfos: list
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/regularPurchase/sort`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$emit('delSuc')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		// 是否开启小类
		checkSmallCategory () {
			// return new Promise((resolve, reject) => {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.bigcategoryview = res.bigcategoryview
			})
			// })
		},
		countInput (row) {
			let data = this.acceptData
			data.forEach(item => {
				if (item.rrpid === row.rrpid) {
					item.itemQuantity = String(item.itemQuantity)
					item.itemQuantity = item.itemQuantity.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
					item.itemQuantity = item.itemQuantity.replace(/^\./g, '')// 验证第一个字符是数字而不是
					item.itemQuantity = item.itemQuantity.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
					item.itemQuantity = item.itemQuantity.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
					switch (this.decimal) {
					case 0:
						item.itemQuantity = item.itemQuantity.replace(/(^[0]|[^\d])/g, '')
						break
					case 1:
						item.itemQuantity = item.itemQuantity.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3')
						break
					case 2:
						item.itemQuantity = item.itemQuantity.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
						break
					case 3:
						item.itemQuantity = item.itemQuantity.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3')
						break
					case 4:
						item.itemQuantity = item.itemQuantity.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3')
						break
					}
					if (item.itemQuantity.indexOf('.') !== -1) {
						if (item.itemQuantity.split('.')[0] === '') {
							item.itemQuantity = ''
						}
					} else {
						if (item.itemQuantity > 9999) {
							item.itemQuantity = 9999
						}
					}
				}
			})
			this.acceptData = data
		},
		getData () {
			return this.acceptData
		},
		selectionChangeHandle (value) {
			let ids = value.map(item => {
				return item.rrpid
			})
			this.$emit('delIds', ids)
		},
		delGoods (data) {
			this.$confirm('是否删除商品？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let params = {
					relListidArr: data.rrpid
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/regularPurchase/rel/delete`,
					data: params
				}).then(res => {
					if (res.result) {
						this.$message.success('删除成功！')
						this.$emit('delSuc')
					} else {
						this.$message.error(res.msg)
					}
				})
			}).catch(() => {})
		},
		getOrderSystemSetting () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/getOrderSystemSetting`
			}).then(res => {
				if (res.result) {
					this.decimal = res.data.orderdecimalcount
				} else {
					this.$message.error(res.msg)
				}
			}).catch((res) => {
				this.$message.error(res.msg)
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.main-table {
	.main-table-box {
		padding-bottom 10px;
		min-height: 200px;
	}
}
</style>
